import { YStack, styled } from 'tamagui'

export const Card = styled(YStack, {
  name: 'Card',
  borderRadius: '$6',
  backgroundColor: '$grey0',
  // @ts-expect-error - boxShadow is a web-only property
  boxShadow: '$boxShadowLight',

  padding: '$5',

  variants: {
    main: {
      true: {
        tag: 'main',
      },
    },
  } as const,
} as const)
